var pathNameHelper = function pathNameHelper(asPath) {
  return asPath.split('?')[0];
};
export default pathNameHelper;